(()=>{
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const visible=new WeakSet(),paused=new WeakSet();
 function initialize(scope=document){
  scope.querySelectorAll('[data-ia-motion]').forEach(video=>{
   if(video.dataset.motionReady)return;video.dataset.motionReady='true';
   const button=video.parentElement.querySelector('[data-motion-toggle]');
   function label(){button.textContent='Replay animation';button.setAttribute('aria-label','Replay animation');button.hidden=reduced.matches;}
   label();button.addEventListener('click',()=>{video.currentTime=0;video.play().catch(()=>{});});
   const observer=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting){visible.add(video);if(!reduced.matches&&!paused.has(video)&&!document.hidden)video.play().catch(()=>{});}else{visible.delete(video);video.pause();}}},{threshold:.2});observer.observe(video);
   reduced.addEventListener('change',()=>{label();if(reduced.matches)video.pause();else if(visible.has(video)&&!paused.has(video))video.play().catch(()=>{});});
  });
 }
 document.addEventListener('visibilitychange',()=>document.querySelectorAll('[data-ia-motion]').forEach(v=>{if(document.hidden)v.pause();else if(visible.has(v)&&!reduced.matches&&!paused.has(v))v.play().catch(()=>{});}));
 initialize();document.addEventListener('shopify:section:load',e=>initialize(e.target));
})();
